import { render, staticRenderFns } from "./ItemWarn.vue?vue&type=template&id=1a355d46&scoped=true&"
import script from "./ItemWarn.vue?vue&type=script&lang=js&"
export * from "./ItemWarn.vue?vue&type=script&lang=js&"
import style0 from "./ItemWarn.vue?vue&type=style&index=0&id=1a355d46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a355d46",
  null
  
)

export default component.exports